'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Listener = require('../../shared/VideoStore/Listener');

var _State = require('../../shared/VideoStore/State');

var _State2 = _interopRequireDefault(_State);

var _constants = require('../actions/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MIGRATION = 'MIGRATION';
var CACHE_KEYS = [_constants.SET_FOCUS];

/**
 * This middleware acts as a hook to build new StateSnapshots when redux actions are fired.
 * This ensures that all legacy components are made aware of new values on migrated state keys,
 * however should the action be a 'MIGRATION' action, then it has come from an updateState cycle
 * and we know that at the end of that cycle a new StateSnapshot is generated, so we don't need to.
 * @param {function} next - middleware
 * @returns {any} - middleware
 */

exports.default = function () {
  return function (next) {
    return function (action) {
      var result = next(action);
      if (action.type.indexOf(MIGRATION) === -1) {
        (0, _Listener.listener)(_State2.default.generateSnapshot(true));
      }
      if (CACHE_KEYS.indexOf(action.type) !== -1) {
        (0, _Listener.listener)(_State2.default.getCachedSnapshot());
      }
      return result;
    };
  };
};

module.exports = exports['default'];